import { render, staticRenderFns } from "./DragContainer.vue?vue&type=template&id=33a7233f&"
import script from "./DragContainer.vue?vue&type=script&lang=js&"
export * from "./DragContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports